export default () => {
  if (window.innerWidth <= 700) return 87;
  if (window.innerWidth <= 900) return 70;

  return 0;
};
